import { fetch } from "core/util";
import { API_PREFIX } from "app/constants";
import { ExternalEpinResult } from "model/epinExternal";

export default {
    resendEpin: (hash) => fetch.doPost(`${API_PREFIX}/resendpin/${hash}`, {}, undefined, ExternalEpinResult.fromServer),
};
